/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Doc_Claim_AriaInputs */

const en_faq_doc_claim_aria = /** @type {(inputs: Faq_Doc_Claim_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Submitting A Claim Document`)
};

const fr_faq_doc_claim_aria = /** @type {(inputs: Faq_Doc_Claim_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers le document Guide de soumission de réclamation`)
};

/**
* | output |
* | --- |
* | "Link to Submitting A Claim Document" |
*
* @param {Faq_Doc_Claim_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_doc_claim_aria = /** @type {((inputs?: Faq_Doc_Claim_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Doc_Claim_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_doc_claim_aria(inputs)
	return fr_faq_doc_claim_aria(inputs)
});